import React, { useState } from "react";
import CupRenameInput from "./CupRenameInput";

export default function CupSelectorColumn({
  cups,
  selectedCupId,
  onSelect,
  onRename,
  onRemove,
  onAdd,
  onReorder,
}) {
  const [editingId, setEditingId] = useState(null);
  const [adding, setAdding] = useState(false);
  const existingNames = cups.map((c) => c.name);

  const handleRename = (cupId, newName) => {
    const result = onRename(cupId, newName);
    if (result.ok) setEditingId(null);
  };

  const handleAdd = (name) => {
    const result = onAdd(name);
    if (result.ok) setAdding(false);
  };

  const moveUp = (idx) => {
    if (idx === 0) return;
    const ids = cups.map((c) => c.id);
    [ids[idx - 1], ids[idx]] = [ids[idx], ids[idx - 1]];
    onReorder(ids);
  };

  const moveDown = (idx) => {
    if (idx === cups.length - 1) return;
    const ids = cups.map((c) => c.id);
    [ids[idx + 1], ids[idx]] = [ids[idx], ids[idx + 1]];
    onReorder(ids);
  };

  return (
    <div className="flex flex-col gap-2 w-44">
      <h4 className="text-sm font-semibold text-fifth">Fincan</h4>
      {cups.map((cup, idx) => (
        <div
          key={cup.id}
          className={`border rounded p-2 cursor-pointer ${
            cup.id === selectedCupId
              ? "border-main bg-main/10"
              : "border-fifth"
          }`}
          onClick={() => onSelect(cup.id)}
        >
          {editingId === cup.id ? (
            <CupRenameInput
              initialValue={cup.name}
              existingNames={existingNames.filter((n) => n !== cup.name)}
              onSave={(name) => handleRename(cup.id, name)}
              onCancel={() => setEditingId(null)}
            />
          ) : (
            <div className="flex items-center justify-between">
              <span className="font-medium">{cup.name}</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setEditingId(cup.id);
                }}
                className="text-xs"
                title="Yeniden adlandır"
              >
                ✎
              </button>
            </div>
          )}
          <div className="flex items-center gap-1 mt-1 text-xs">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                moveUp(idx);
              }}
              disabled={idx === 0}
            >
              ▲
            </button>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                moveDown(idx);
              }}
              disabled={idx === cups.length - 1}
            >
              ▼
            </button>
            {!cup.isSystem && (
              <button
                type="button"
                className="ml-auto text-red-600"
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm(`${cup.name} fincanını sil?`))
                    onRemove(cup.id);
                }}
              >
                🗑
              </button>
            )}
          </div>
        </div>
      ))}
      {adding ? (
        <div className="border border-dashed rounded p-2">
          <CupRenameInput
            existingNames={existingNames}
            onSave={handleAdd}
            onCancel={() => setAdding(false)}
          />
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setAdding(true)}
          className="border border-dashed border-fifth/50 rounded p-2 text-fifth hover:bg-fifth/5"
        >
          + Fincan Ekle
        </button>
      )}
    </div>
  );
}
